import React from 'react';
import { useTheme } from '../context/ThemeContext';

function Privacy() {
  const { theme } = useTheme();
  return (
    <div className={`container mx-auto p-8 ${theme.text} opacity-90`}>
      <div className={`${theme.cardBg} rounded-lg mt-8 shadow-lg p-6 text-left border ${theme.border}`}>
        <h1 className="text-3xl font-bold mb-6">Privacy Policy</h1>

        <div className="space-y-4">
            <p className="font-bold">Last Updated: April 7, 2025</p>

          <section className="mb-6">
            <h2 className="text-2xl font-bold mb-3">Information We Collect</h2>
            <p>
              We collect minimal information to provide you with the best possible experience. This includes:
            </p>
            <ul className="list-disc pl-6 mt-2">
              <li>Browser cache data for improved performance</li>
              <li>Usage analytics to improve our service</li>
              <li>If you contact us through our website or LinkedIn page, we will collect your name, email address, and any other information you provide.</li>
              <li>If you subscribe to our newsletter on Substack, we will collect your name and email address.</li>
            </ul>
          </section>

          <section className="mb-6">
            <h2 className="text-2xl font-bold mb-3">How We Use Your Information</h2>
            <p>
              The information we collect is used solely to:
            </p>
            <ul className="list-disc pl-6 mt-2">
              <li>Improve the functionality of our website</li>
              <li>Analyze site usage patterns</li>
              <li>Enhance user experience</li>
              <li>If you contact us through our website or LinkedIn page, we will use your information to respond to your message or provide any services requested.</li>
              <li>If you subscribe to our newsletter on Substack, we will use your email address to send you the newsletter.</li>
            </ul>
          </section>

          <section className="mb-6">
            <h2 className="text-2xl font-bold mb-3">Data Storage</h2>
            <p>
              We use local storage to cache event data temporarily on your device to improve performance
              and reduce server load. This data is automatically cleared based on cache expiration rules.
            </p>
          </section>

          <section className="mb-6">
            <h2 className="text-2xl font-bold mb-3">Tracking Technologies</h2>
            <p>
              We use products from Google and Microsoft to collect usage data. This data is anonymous and cannot be used by us to identify you personally.
            </p>
            <p>
              We use Substack to send our newsletter. Substack is a third-party service that we use to send our newsletter. Please consult their <a href="https://substack.com/privacy" target="_blank" rel="noopener noreferrer" className={theme.link}>privacy policy</a> for more information.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-3">Contact Us</h2>
            <p>
              If you have any questions about our privacy policy, please contact us at <a target="_blank" rel="noopener noreferrer" className={theme.link} href="https://www.linkedin.com/company/atl-tech-events">ATLTech.events<sup>SM</sup> on LinkedIn</a>.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}

export default Privacy;
